import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { Chips } from "@website/ui/chips";
import { MiniChips } from "@website/ui/mini-chips";
import { Tooltip } from "@website/ui/tooltip";
import { numberConvert } from "@website/utils/number-convert";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { FC } from "react";
import type { AccommodationCardMediaPropertiesType } from "./accommodation-card-media.types";
type AccommodationCardMediaBadgesProperties = Pick<AccommodationCardMediaPropertiesType, "badges" | "id">;
export const AccommodationCardMediaBadges: FC<AccommodationCardMediaBadgesProperties> = t0 => {
  const $ = _c(10);
  const {
    badges,
    id
  } = t0;
  const router = useCompatRouter();
  const {
    isDesktop
  } = useViewPort();
  const partnershipBadge = badges?.partnership;
  if (!partnershipBadge?.text && !badges?.instant) {
    return null;
  }
  let t1;
  if ($[0] !== badges?.instant) {
    t1 = badges?.instant && <MiniChips StartIcon={<MaterialIcon name="bolt" className="text-[#ED5F07]" variant="round" />} className="!text-on-surface-high-emphasis !h-[24px] shrink-0 !gap-0.5 !bg-[linear-gradient(0deg,_rgba(237,95,7,0.1),_rgba(237,95,7,0.1)),linear-gradient(0deg,_#FFFFFF,_#FFFFFF)]" text={"\u0631\u0632\u0631\u0648 \u0622\u0646\u06CC"} variant="round-contained" textClassName="!text-[12px] pb-0.5 font-[500] !text-[#ED5F07]" />;
    $[0] = badges?.instant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id || $[3] !== isDesktop || $[4] !== partnershipBadge || $[5] !== router) {
    t2 = partnershipBadge?.text && <Tooltip className="min-w-0 flex-1 cursor-pointer" title={`${numberConvert(partnershipBadge?.description, {
      locale: "fa"
    })}`} titleClassName="hidden !max-w-[250px] md:block !transform-none !left-0 right-0 !top-7"><Chips EndIcon={<div className="flex size-5 items-center justify-center"><MaterialIcon className="text-[20px] leading-5" name="info" variant="outlined" /></div>} className={`!text-on-surface-high-emphasis !h-[24px] min-w-0 max-w-full ${partnershipBadge.color === "#FFAF00" ? "bg-[linear-gradient(180deg,_#FFDF38_0%,_#FFAF00_100%)]" : "!bg-white"} !w-full`} textStyle="!text-[12px]" textClassName="min-w-0 truncate !px-1" color={partnershipBadge.color} onClick={event => {
        if (isDesktop) {
          return;
        }
        event.stopPropagation();
        event.preventDefault();
        return router.replace(router.pathname, {
          ...router?.query,
          modal: `badge-info-${id}`
        }, {
          shallow: true,
          scroll: false
        });
      }} text={numberConvert(partnershipBadge.text, {
        locale: router.locale
      })} /></Tooltip>;
    $[2] = id;
    $[3] = isDesktop;
    $[4] = partnershipBadge;
    $[5] = router;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="absolute right-3 top-2 z-[1] flex max-w-[calc(100%-24px)] items-center gap-1" dir="rtl">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};